// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-confirm-dialog-docs',
    templateUrl: './confirm-dialog.docs.generated.html',
})
export class UIConfirmDialogDocs { }
